import { Component, OnInit } from '@angular/core';

import { NgxPermissionsModule, NgxPermissionsGuard } from 'ngx-permissions';
import { HasLocationsGuard} from './services/guards/has-locations-guard';
import { AuthTokenService } from './services/appInitialization/authToken.service';
import { AuthUserService } from './services/appInitialization/authUser.service';

import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';

import { User } from './models/user.model'; 
import { Router } from '@angular/router'; 
import { HttpStatusNotifierService } from './services/http-status-notifier.service';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
 
 private _user: User;
 constructor(private router: Router, private localStorage: LocalStorage,
             private authUserService: AuthUserService, private spinner: NgxSpinnerService,
             private httpStatus: HttpStatusNotifierService, private notifier: NotifierService){}

  ngOnInit() {

    this.displayUserNotification();

    this._user = this.authUserService.AuthUser;
    if(this._user == undefined)
    {
      
    }
    else
    {
      if (this._user.userStatus.id == 2){
        this.router.navigate(['registration']); //navigate pending activation page
      } else {
        if (this._user.userType.typeName != "Unknown" && this._user.userLocations.length == 0) {
          this.router.navigate(['user-profile']);
        }
        else
        {
          this.router.navigate(['']);
        }
      }
    }

    this.httpStatus.getHttpStatus().subscribe((status:boolean) => {
      if(status) {
        this.spinner.show();
      }
      if(!status){
        this.spinner.hide();
      }
    });
  }

  private async displayUserNotification() : Promise<void> {
    return await this.localStorage.getItem('UserNotification')
                                  .toPromise()
                                  .then((notification: string) => {
                                    if (!(notification == null)) {
                                      this.showNotification('error', notification);
                                      this.localStorage.removeItem('UserNotification')
                                                       .subscribe(() => {});
                                    }
                                  });
  }

  public showNotification( type: string, message: string ): void {
		this.notifier.notify( type, message );
	}
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts